import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './BankRecords.css';
import {
  Typography, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, CircularProgress
} from '@mui/material';

const BankRecords = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState("All");
  const [form, setForm] = useState({
    date: '', type: '', amount: '', mode: '',
    bank: '', cheque_number: '', transaction_id: '', description: ''
  });

  useEffect(() => {
    fetchBankRecords();
  }, []);

  const fetchBankRecords = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/backend/api/get_bank_records.php', {
        withCredentials: true,
      });
      setRecords(response.data);
    } catch (error) {
      console.error("Failed to fetch bank records:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.date || !form.type || !form.amount) {
      alert("Date, Type, and Amount are required.");
      return;
    }

    try {
      await axios.post('/backend/api/add_bank_record.php', form, {
        withCredentials: true,
      });
      alert("Record added successfully.");
      setForm({
        date: '', type: '', amount: '', mode: '',
        bank: '', cheque_number: '', transaction_id: '', description: ''
      });
      fetchBankRecords();
    } catch (error) {
      console.error("Failed to add record:", error);
      alert("Failed to add record.");
    }
  };

  const filteredRecords = filterType === "All"
    ? records
    : records.filter((r) => r.type === filterType);

  const totalCredit = records
    .filter(r => r.type === "Credit")
    .reduce((sum, r) => sum + parseFloat(r.amount || 0), 0);

  const totalDebit = records
    .filter(r => r.type === "Debit")
    .reduce((sum, r) => sum + parseFloat(r.amount || 0), 0);

  return (
    <div className="bank-records-wrapper">
      <div className="records-header">
        <h2>Bank Records</h2>
        <div className="totals">
          <span><strong>Total Credited:</strong> ₹{totalCredit.toFixed(2)}</span>
          <span><strong>Total Debited:</strong> ₹{totalDebit.toFixed(2)}</span>
        </div>
      </div>

      {/* Filter */}
      <div className="filter-bar">
        <label>Filter by Type: </label>
        <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
          <option value="All">All</option>
          <option value="Credit">Credit</option>
          <option value="Debit">Debit</option>
        </select>
      </div>

      {/* Add Record Form */}
      <Paper className="form-section" elevation={3}>
        <h3>Add New Record</h3>
        <div className="form-grid">
          <input type="date" name="date" value={form.date} onChange={handleChange} />
          <select name="type" value={form.type} onChange={handleChange}>
            <option value="">Select Type</option>
            <option value="Credit">Credit</option>
            <option value="Debit">Debit</option>
          </select>
          <input type="number" name="amount" value={form.amount} onChange={handleChange} placeholder="Amount" />
         <select name="mode" value={form.mode} onChange={handleChange}>
  <option value="">Select Mode</option>
  <option value="UPI">UPI</option>
  <option value="CASH">CASH</option>
  <option value="CHEQUE">CHEQUE</option>
</select>

          <input type="text" name="bank" value={form.bank} onChange={handleChange} placeholder="Bank" />
          <input type="text" name="cheque_number" value={form.cheque_number} onChange={handleChange} placeholder="Cheque No" />
          <input type="text" name="transaction_id" value={form.transaction_id} onChange={handleChange} placeholder="Transaction ID" />
          <input type="text" name="description" value={form.description} onChange={handleChange} placeholder="Description" />
        </div>
        <button className="add-button" onClick={handleSubmit}>Add Record</button>
      </Paper>

      {/* Data Table */}
      {loading ? (
        <div className="loading"><CircularProgress /></div>
      ) : (
        <TableContainer component={Paper} className="table-section">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Mode</TableCell>
                <TableCell>Bank</TableCell>
                <TableCell>Cheque No</TableCell>
                <TableCell>Transaction ID</TableCell>
                <TableCell>Description</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRecords.length > 0 ? (
                filteredRecords.map((record, index) => (
                  <TableRow key={index}>
                    <TableCell>{record.date}</TableCell>
                    <TableCell>{record.type}</TableCell>
                    <TableCell>{record.amount}</TableCell>
                    <TableCell>{record.mode}</TableCell>
                    <TableCell>{record.bank}</TableCell>
                    <TableCell>{record.cheque_number}</TableCell>
                    <TableCell>{record.transaction_id}</TableCell>
                    <TableCell>{record.description}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">No matching records found.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default BankRecords;
